<template>
  <div>
    <!-- Mobile navigation -->
    <nav class="p-3 lg:hidden">
      <div class="flex items-center">
        <div class="flex-grow">
          <div class="font-bold pl-2">
              {{ orgSettings.applicationDisplayName }}
          </div>
        </div>
        <div class="lg:hidden flex-shrink">
          <button class="px-3 py-3 border rounded text-primary border-primary hover:text-primary-focus hover:border-primary-focus transition-colors" @click="expanded=!expanded">
            <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
      </div>

      <div class="w-full">
        <d-expand-transition>
          <div v-if="expanded" class="block flex-grow lg:flex lg:items-center lg:w-auto">
            <div class="text-sm lg:flex-grow pt-5 px-5">
              <div v-for="item in filteredNavItems" :key="item.path" class="mb-3">
                <!-- Main navigation item -->
                <div v-if="!item.hideFromNav" class="mb-2">
                  <a @click.prevent="navigateTo(item.path)" class="block py-2 text-base font-medium text-gray-900 hover:text-primary no-underline cursor-pointer">
                    {{ item.title }}
                  </a>
                </div>
                
                <!-- Child navigation items -->
                <ul v-if="item.children && item.children.length > 0" class="pl-4 space-y-1">
                  <template v-for="childItem in item.children" :key="childItem.path">
                    <li v-if="userHasAccess(childItem) && !childItem.hideFromNav">
                      <a @click.prevent="navigateTo(childItem.path)" class="block py-1 text-sm text-gray-700 hover:text-primary no-underline cursor-pointer">
                        {{ childItem.title }}
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </d-expand-transition>
      </div>
    </nav>

    <!-- Desktop header -->
    <div class="flex justify-end">
      <div class="pr-16 hidden lg:block">
        <d-dropdown aria-role="list">
          <template #activator>
            <div class="flex items-center select-none">
              <d-avatar :text="profile.fullName" :img-src="profile.profileImageUrl" class="mr-3 my-0" size="30px" />
              <span>{{ profile.fullName }}</span>
            </div>
          </template>

          <li>
            <a href="/profile" >My Profile</a>
          </li>
          <li>
            <a href="/manageaccount/changepassword" >Change Password</a>
          </li>
          <li>
            <a href="/account/supportlogin" target="_blank">Support</a>
          </li>
          <li>
            <a href="/account/logout">Logout</a>
          </li>
        </d-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { useAuthStore } from '@stores/auth';
  import { routes } from '../routing/index';

  export default {
    parent: true,

    data() {
      return {
        expanded: false,
        navItems: routes,
      };
    },
    props: {
        orgSettings: {
            type: Object,
            default: () => null,
        },
    },
    computed: {
        authStore() {
            return useAuthStore();
        },
        profile() {
            return this.authStore.profile;
        },
        loggedIn() {
            return this.authStore.loggedIn;
        },
        hasAnyClaim() {
            // Safely access hasAnyClaim method from authStore
            return this.authStore && typeof this.authStore.hasAnyClaim === 'function' 
                ? this.authStore.hasAnyClaim 
                : () => false;
        },
        filteredNavItems() {
            return this.navItems.filter(item => this.userHasAccess(item));
        },
    },
     mounted() {
         if (this.loggedIn) {
             this.startAuthCheck();
         }
     },
     methods: {
            startAuthCheck() {
                setInterval(async () => {
                    try {
                        await axios.get('/api/auth/check');
                    } catch (error) {
                        // Axios interceptor will handle 401
                    }
                }, 60000);
            },
      
      handleNavigation() {
        // Close the mobile menu after navigation
        this.expanded = false;
        
        // Force a page reload if we're navigating to the same route or if navigation doesn't work
        this.$nextTick(() => {
          // Small delay to ensure router has processed the navigation
          setTimeout(() => {
            if (this.$route.path === this.$router.currentRoute.value.path) {
              // If we're on the same route, force a reload
              window.location.reload();
            }
          }, 100);
        });
      },

      navigateTo(path) {
        // Close the mobile menu
        this.expanded = false;
        
        // Use window.location for full page navigation
        // This ensures the page actually navigates instead of just changing the URL
        window.location.href = path;
      },

      userHasAccess(item) {
        if (item.claims) {
          // Check if authStore and hasAnyClaim method exist and claims data is available
          if (this.authStore && typeof this.authStore.hasAnyClaim === 'function') {
            return this.authStore.hasAnyClaim(item.claims);
          }
          // If authStore is not ready or claims data is missing, default to false for safety
          console.warn('Auth store not ready or claims data missing for item:', item);
          return false;
        }

        return true;
      },
    },
  };
</script>